export const internalServerErrorMessage = 'Ops! Ocorreu um problema desconhecido, tente entrar novamente!';
export const badRequestErrorMessage = '';
